var $ = require('jquery');
var AOS = require('aos');
// var styleguide = require('./modules/style-guide.js');
// var accordions = require('./modules/accordions.js');
// var cards = require('./modules/cards.js');
var menu = require('./modules/menu.js');
var highlightUnderlines = require('./modules/highlight-underlines.js');
var fancyapps = require('./modules/fancyapps.js');
var localization = require('./modules/localization.js');
var mediaSliders = require('./modules/media-sliders.js');
var scrollTo = require('./modules/scrollto.js');
var sliders = require('./modules/sliders.js');
var stats = require('./modules/stats.js');
var testimonials = require('./modules/testimonials.js');
var resourceFilters = require('./modules/resource-filters.js');
var tablepressScopeAttr = require('./modules/tablepress-scope-attr.js');
// var heroNavAriaLabels = require('./modules/hero-nav-aria-labels.js');
var pagerFacetActive = require('./modules/pager-facet-active.js');
var facetWpResultsAnnouncement = require('./modules/facetwp-results-announcement.js');

// var svg = require('./modules/svg.js');

// Make sure that you init the styleguide first.
// styleguide.init();
// accordions.init();
// cards.init();
AOS.init();
menu.init();
highlightUnderlines.init();
// heroNavAriaLabels.init();
fancyapps.init();
//localization.init();
mediaSliders.init();
scrollTo.init();
sliders.init();
stats.init();
testimonials.init();
resourceFilters.init();
tablepressScopeAttr.init();
pagerFacetActive.init();
facetWpResultsAnnouncement.init();
// svg.init();
